import { useContext, useRef,useEffect ,useState } from "react";
import { fetchData } from "../../fetcher";
import TheMallOutletLayout from "../../layouts/TheMallOutletLayout/TheMallOutletLayout";
import styles from "./GolfForm.module.scss";
import ScrollDown from "../../components/ScrollDown/ScrollDown";
import { ApplicationContext } from "../../context/ApplicationContext";
import { useRouter } from "next/dist/client/router";
import { Controller, useForm } from "react-hook-form";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ReactDOMServer from "react-dom/server";
import CloseIcon from "../../public/assets/icons/closeIcon.svg";
import Swal from "sweetalert2";

const langStrings = {
  'it': {
    'full_name': 'Nome e cognome',
    'circolo': 'Circolo di appartenenza',
    'handicap': 'Handicap di gioco',
    'email': 'Email',
    'hospitality': 'Sono interessato al pacchetto "Hospitality"',
    'privacy': 'Acconsento al trattamento dei <a target="_blank" href="https://sanremo.themall.it/en/privacy-policy">dati personali</a>',
    'cta': 'Invia',
    'info': 'Per maggiori informazioni ed approfondimenti non esitare a contattarci <a href="mailto:sanremo@themall.it">sanremo@themall.it</a>'
  },
  'fr': {
    'full_name': 'Nom Prénom',
    'circolo': 'Club d\'Appartenance',
    'handicap': 'Handicap',
    'email': 'Email',
    'hospitality': 'Je suis intéressé par le forfait "Hospitalité"',
    'privacy': 'Vous autoriser le traitement des <a target="_blank" href="https://sanremo.themall.it/en/privacy-policy">données personnelles</a>',
    'cta': 'Envoyez votre demand',
    'info': 'Pour plus d\'informations et d\'idées, n\'hésitez pas à nous contacter <a href="mailto:sanremo@themall.it">sanremo@themall.it</a>'
  },
  'en': {
    'full_name': 'First and Last name',
    'circolo': 'Circle of membership',
    'handicap': 'Game Handicap',
    'email': 'Email',
    'hospitality': 'I am interested in Hospitality offers',
    'privacy': 'You agree to the <a target="_blank" href="https://sanremo.themall.it/en/privacy-policy">processing of your personal data</a>',
    'cta': 'Send',
    'info': 'For more information and insights do not hesitate to contact us <a href="mailto:sanremo@themall.it">sanremo@themall.it</a>'
  },
  'jp': {
    'full_name': 'First and Last name',
    'circolo': 'Circle of membership',
    'handicap': 'Game Handicap',
    'email': 'Email',
    'hospitality': 'I am interested in Hospitality offers',
    'privacy': 'You agree to the <a target="_blank" href="https://sanremo.themall.it/en/privacy-policy">processing of your personal data</a>',
    'cta': 'Send',
    'info': 'For more information and insights do not hesitate to contact us <a href="mailto:sanremo@themall.it">sanremo@themall.it</a>'
  },
  'kr': {
    'full_name': 'First and Last name',
    'circolo': 'Circle of membership',
    'handicap': 'Game Handicap',
    'email': 'Email',
    'hospitality': 'I am interested in Hospitality offers',
    'privacy': 'You agree to the <a target="_blank" href="https://sanremo.themall.it/en/privacy-policy">processing of your personal data</a>',
    'cta': 'Send',
    'info': 'For more information and insights do not hesitate to contact us <a href="mailto:sanremo@themall.it">sanremo@themall.it</a>'
  },
  'zh': {
    'full_name': 'First and Last name',
    'circolo': 'Circle of membership',
    'handicap': 'Game Handicap',
    'email': 'Email',
    'hospitality': 'I am interested in Hospitality offers',
    'privacy': 'You agree to the <a target="_blank" href="https://sanremo.themall.it/en/privacy-policy">processing of your personal data</a>',
    'cta': 'Send',
    'info': 'For more information and insights do not hesitate to contact us <a href="mailto:sanremo@themall.it">sanremo@themall.it</a>'
  },
  'ru': {
    'full_name': 'First and Last name',
    'circolo': 'Circle of membership',
    'handicap': 'Game Handicap',
    'email': 'Email',
    'hospitality': 'I am interested in Hospitality offers',
    'privacy': 'You agree to the <a target="_blank" href="https://sanremo.themall.it/en/privacy-policy">processing of your personal data</a>',
    'cta': 'Send',
    'info': 'For more information and insights do not hesitate to contact us <a href="mailto:sanremo@themall.it">sanremo@themall.it</a>'
  }
}
const errorStrings = {
  'it': {
    'full_name': 'Inserisci nome e cognome',
    'circolo': 'Inserisci il circolo di appartenenza',
    'handicap': 'Inserisci handicap di gioco',
    'email': 'Inserisci l\'email',
    'hospitality': 'Inserisci hospitality',
    'privacy': 'Accetta il trattamento dei dati personali'
  },
  'en': {
    'full_name': 'Insert first and last name',
    'circolo': 'Insert Circle of membership',
    'handicap': 'Insert game handicap',
    'email': 'Insert email',
    'hospitality': 'Insert hospitality',
    'privacy': 'Accept the processing of personal data'
  },
  'fr': {
    'full_name': 'Indiquez votre nom et prénom',
    'circolo': 'Indiquez le Club d\'appartenance',
    'handicap': 'Indiquez handicap',
    'email': 'Indiquez l\'adresse e-mail',
    'hospitality': 'Inserisci hospitality',
    'privacy': 'Acceptez le traitement des données personnelles'
  },
  'jp': {
    'full_name': 'Insert first and last name',
    'circolo': 'Insert Circle of membership',
    'handicap': 'Insert game handicap',
    'email': 'Insert email',
    'hospitality': 'Insert hospitality',
    'privacy': 'Accept the processing of personal data'
  },
  'kr': {
    'full_name': 'Insert first and last name',
    'circolo': 'Insert Circle of membership',
    'handicap': 'Insert game handicap',
    'email': 'Insert email',
    'hospitality': 'Insert hospitality',
    'privacy': 'Accept the processing of personal data'
  },
  'zh': {
    'full_name': 'Insert first and last name',
    'circolo': 'Insert Circle of membership',
    'handicap': 'Insert game handicap',
    'email': 'Insert email',
    'hospitality': 'Insert hospitality',
    'privacy': 'Accept the processing of personal data'
  },
  'ru': {
    'full_name': 'Insert first and last name',
    'circolo': 'Insert Circle of membership',
    'handicap': 'Insert game handicap',
    'email': 'Insert email',
    'hospitality': 'Insert hospitality',
    'privacy': 'Accept the processing of personal data'
  }
}
const results = {
  'it': {
    'ok': 'Grazie per la tua iscrizione, riceverai una email di conferma al più presto.',
    'ko': 'Si è verificato un errore'
  },
  'en': {
    'ok': 'Thank you for your registration, you will receive a confirmation email soon.',
    'ko': 'An error has occured'
  },
  'fr': {
    'ok': 'Merci pour votre inscription, vous allez recevoir un mail de confirmation au plus vite.',
    'ko': 'Une erreur est survenue'
  },
  'jp': {
    'ok': 'Thank you for your registration, you will receive a confirmation email soon.',
    'ko': 'An error has occured'
  },
  'kr': {
    'ok': 'Thank you for your registration, you will receive a confirmation email soon.',
    'ko': 'An error has occured'
  },
  'zh': {
    'ok': 'Thank you for your registration, you will receive a confirmation email soon.',
    'ko': 'An error has occured'
  },
  'ru': {
    'ok': 'Thank you for your registration, you will receive a confirmation email soon.',
    'ko': 'An error has occured'
  }
}

const GolfForm = ({ menuItems, dataContent, properties }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    getValues,
    control,
  } = useForm();
  let router = useRouter();  
  const scrollToRef = useRef(null)
  const locale = router.query.locale;
  const langStr = langStrings[locale];
  const errStr = errorStrings[locale];

  const thisRef = useRef();
  useEffect(() => {
    let countCi = 0;
    let ci = setInterval(() => {
      if (thisRef?.current?.querySelector('input')) {
        const autoFill =
          window
            .getComputedStyle(thisRef.current.querySelector('input'), ':internal-autofill-selected')
            .getPropertyValue('appearance') === 'menulist-button';
        if (autoFill) {
          thisRef.current.querySelector('input').focus();
          clearInterval(ci);
          return;
        }
        countCi++;
        if (countCi >= 10) {
          clearInterval(ci);
          return;
        }
      }
    }, 500)
  }, [thisRef]);
  const { setShowLoader } = useContext(ApplicationContext);
  const [flexible, setFlexible] = useState(false);

  const onSubmit = async (data) => {
    console.log('submit data', data);
    setShowLoader(true);
    let baseUrl = `${process.env.NEXT_PUBLIC_DATA_BASEURL}`;
    let url = baseUrl.replace("wp-json", router.query.locale + "/wp-json");
    url = url + "/golfbooking"


    let postdata = {
      slug: router.asPath,
      full_name: data.full_name,
      email: data.email,
      circolo: data.circolo,
      handicap: data.handicap,
      hospitality: data.hospitality,
      privacy: data.privacy
    };
   
    //return;
    const res = await fetch(
      url,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(postdata),
      }
    );
    const resjs = await res.json();
    let message =
      resjs == true
        ? results[locale]['ok']
        : results[locale]['ko'];
    setShowLoader(false);
    Swal.fire({
      title: message,
      showCloseButton: true,
      showCancelButton: false,
      showConfirmButton: false,
      closeButtonHtml: ReactDOMServer.renderToString(<CloseIcon />),
    });
  };

  return (
    <div className={styles.formContainer} style={{marginTop: '75px', marginBottom: '75px'}}>
      <form onSubmit={handleSubmit(onSubmit)} className={styles.Form}>
        
        <label>
          <input
            className={styles.bordered}
            placeholder=" "
            type={'text'}
            {...register(`full_name`, {
              required: true,
              pattern:
                /[a-zA-ZÀ-ž]{1}[\sa-zA-ZÀ-ž\-']{1,500}[\s][a-zA-ZÀ-ž]{1}[\sa-zA-ZÀ-ž\-']{1,500}$/,
            })}
          />
          <span>{langStr['full_name']}</span>
          {errors['full_name'] &&
            <div className={styles.error}>
              <FontAwesomeIcon icon={faExclamationTriangle} />
              &nbsp;
              {errStr['full_name']}
            </div>
          }
        </label>

        <label>
          <input
            className={styles.bordered}
            placeholder=" "
            type={'text'}
            {...register(`circolo`, {
              required: true,
            })}
          />
          <span>{langStr['circolo']}</span>
          {errors['circolo'] &&
            <div className={styles.error}>
              <FontAwesomeIcon icon={faExclamationTriangle} />
              &nbsp;
              {errStr['circolo']}
            </div>
          }
        </label>

        <label>
          <input
            className={styles.bordered}
            placeholder=" "
            type={'text'}
            {...register(`handicap`, {
              required: true,
            })}
          />
          <span>{langStr['handicap']}</span>
          {errors['handicap'] &&
            <div className={styles.error}>
              <FontAwesomeIcon icon={faExclamationTriangle} />
              &nbsp;
              {errStr['handicap']}
            </div>
          }
        </label>

        <label>
          <input
            className={styles.bordered}
            placeholder=" "
            type={'email'}
            {...register(`email`, {
              required: true,
              pattern: /^[a-zA-Z0-9_+-]+(\.[a-zA-Z0-9_+-]+)*@[a-zA-Z0-9\-]+(\.[a-zA-Z0-9\-]+)*(\.[a-zA-Z]{2,})$/,
            })}
          />
          <span>{langStr['email']}</span>
          {errors['email'] &&
            <div className={styles.error}>
              <FontAwesomeIcon icon={faExclamationTriangle} />
              &nbsp;
              {errStr['email']}
            </div>
          }
        </label>

        <label className={styles.forcheckbox}>
          <input
            placeholder=" "
            type={'checkbox'}
            {...register(`hospitality`, {
              
            })}
            value="yes"
          />
          <span>{langStr['hospitality']}</span>
          {errors['hospitality'] &&
            <div className={styles.error}>
              <FontAwesomeIcon icon={faExclamationTriangle} />
              &nbsp;
              {errStr['hospitality']}
            </div>
          }
        </label>

        <label className={styles.forcheckbox} style={{marginTop: '-3em'}}>
          <input
            placeholder=" "
            type={'checkbox'}
            {...register(`privacy`, {
              required: true,
            })}
          />
          <span dangerouslySetInnerHTML={{__html: langStr['privacy']}}></span>
          {errors['privacy'] &&
            <div className={styles.error}>
              <FontAwesomeIcon icon={faExclamationTriangle} />
              &nbsp;
              {errStr['privacy']}
            </div>
          }
        </label>

        <div dangerouslySetInnerHTML={{__html: langStr['info']}} className={styles.info}></div>

        <input type="submit" value={langStr['cta']} />

      </form>
    </div>
  );
};

export default GolfForm;